var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 right-0 h-screen w-screen max-w-5xl"},[_c('div',{staticClass:"relative flex h-full flex-col overflow-y-scroll bg-ontick-carbon-500 bg-opacity-90 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }